import React, { useState, useEffect } from "react";
import { Grid, Typography, Box } from "@material-ui/core";
import styled from 'styled-components'
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import firebase from "../../config/firebase/index";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga";
import ToggleButton from "../../component/ToggleButton/index.jsx";
import encSecret from "../../config/encryption/index.js";
var CryptoJS = require("crypto-js");


const SignUp = (props) => {

    const history = useHistory();
    const classes = useStyles();
    const [name, setName] = useState('');
    const [city, setCity] = useState('');
    const number = localStorage.getItem("Phone Number");
    const [nameFlag, setNameFlag] = useState(true);
    const [cityFlag, setCityFlag] = useState(true);
    const [isToggled, setIsToggled] = useState(false);
    const whatsappOpInText = "व्हाट्सएप संदेशों के लिए ऑप्ट-इन करें";

    const nameAnalytics = (category, action, label) => {

        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
          category: category,
          action: action,
          label: label,
        })
      }

      const cityAnalytics = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
          category: category,
          action: action,
          label: label,
        })
      }

    const AddedUser = () => {

        firebase.database().ref("Users").orderByChild("PhoneNo")
            .equalTo(localStorage.getItem("Phone Number")).once("value", snapshot => {

                const userData = snapshot.val();

                const user = [];
                for (const key in userData) {

                    const quoteObj = {
                        id: key,
                        ...userData[key],
                    };
                    user.push(quoteObj);
                }
                if (userData) {
                    localStorage.setItem("user", JSON.stringify(user));
                    // history.push("/marketView");
                    history.push("/repeatUser?create=true");
                }

            })
    }


    const handleNameChange = (e) => {
        if (e.target.value === "") {
            setNameFlag(true);
            nameAnalytics("SignUp", "Validation", "Name Field Blank");
        }
        else {
            setName(e.target.value);
            setNameFlag(false);
            nameAnalytics("SignUp", "Value Inserted", "Name filled");

        }

    };

    const handleCityChange = (e) => {
        if (e.target.value === "") {
            setCityFlag(true);
            cityAnalytics("Sign Up", "Validation", "Invalid/Blank City");
        }
        else {
            setCity(e.target.value);
            setCityFlag(false);
            cityAnalytics("Sign Up", "Value Inserted", "City filled");

        }

    };

    const createUser = () => {
        const userRef = firebase.database().ref('Users');
        if (city === "" && name === "") {
            return;
        } else {


            const user = {
                City: city,
                Name: CryptoJS.AES.encrypt(name, encSecret.key).toString(),
                PhoneNo: number,
                // dealerFlag: false,
                dealerFlag: true,
                img: "",
                createAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                whatsappOptIn: isToggled ? true : false,
                whatsappOpInText: whatsappOpInText
            };

            if(isToggled) {
                user['optInDateTime'] = new Date().toISOString();
                user['optOutDateTime'] = '';
            }

            userRef.push(user);
            AddedUser();
        }
    };
    


    return (
        <Grid className={classes.commonFullSection}>
            <Grid className={classes.commonMidSection}>
                <Typography variant="h4" style={{ fontWeight: 600 }} gutterBottom className={classes.purpuleColor}>
                    सौदेबाज़ी
                </Typography>

                <Box mt={4}>
                    <Typography variant="h6" gutterBottom>
                        सौदेबाजी में आपका स्वागत है
                    </Typography>
                </Box>

                <Box mt={4} mb={3}>
                    <Typography variant="h6" style={{ fontWeight: 600 }} gutterBottom>
                        शुरू करने के लिए आपका प्रोफाइल पूरा करें
                    </Typography>
                </Box>


                <Box>
                    <Typography variant="subtitle1" gutterBottom className={classes.labelAlign}>
                        आपका नाम
                    </Typography>
                    <div style={{ display: nameFlag ? "block" : "none" }}>
                        <Typography variant="subtitle1" gutterBottom className={classes.labelAlign}>
                            कृपया अपना पूरा नाम लिखें
                        </Typography>
                    </div>
                    <TextfieldAtom placeholder="अपना नाम लिखे" style={{ fontSize: '16px' }} onChange={handleNameChange} />
                </Box>
                <Box mb={3}>
                    <Typography variant="subtitle1" gutterBottom className={classes.labelAlign}>
                        आपके शहर का नाम
                    </Typography>
                    <div style={{ display: cityFlag ? "block" : "none" }}>
                        <Typography variant="subtitle1" gutterBottom className={classes.labelAlign}>
                            लॉग इन करने के लिए कृपया अपने शहर का नाम दर्ज करें
                        </Typography>
                    </div>
                    <TextfieldAtom placeholder="आप जिस शहर में रहते है" style={{ fontSize: '16px' }} onChange={handleCityChange} />
                </Box>
                <Box className={classes.headerBrowser2}>
                    <ToggleButton rounded={true} isToggled={isToggled} onToggle={(val) => { setIsToggled(val); }} />
                    <Typography variant="h7" className={classes.textMiddleSet}>{whatsappOpInText}</Typography>
                </Box>

                <Box mb={7}>
                    <ButtonAtom
                        name="सौदेबाजी शुरू करो"
                        onClick={createUser}
                    />
                </Box>
            </Grid>
            <Typography variant="caption" gutterBottom className={classes.marginTopAuto}>
                किसी भी मदद के लिए 8696965308 पर कॉल करें
            </Typography>
        </Grid>
    );
};

const useStyles = makeStyles(() => ({
    commonFullSection: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    commonMidSection: {
        maxWidth: 540,
        background: '#fff',
        // boxShadow: '0 0 5px #eee',
        padding: 20,
        boxSizing: 'border-box',
        textAlign: 'center',
        marginTop: 'auto',
        width: 'calc(100% - 60px)',
    },
    marginTopAuto: {
        marginTop: 'auto',
    },
    labelAlign: {
        textAlign: 'left',
        marginTop: 30
    },
    purpuleColor: {
        color: '#53252f',
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        borderColor: '#53252f',
        '& input': {
            paddingLeft: 50,
        }

    },
    textMiddleSet: {
        marginLeft: '0px',
    },
}));

export default SignUp;
